import { ApolloLink } from '@apollo/client'

import { APOLLO_CLIENT_CONTEXT_ID } from 'Config/apolloClient'

import { createChatLink } from './createChatLink'
import { createDatoLink } from './createDatoLink'
import { createMainLink } from './createMainLink'

function createRequestLink(): ApolloLink {
  const datoLink = createDatoLink()
  const chatLink = createChatLink()
  const mainLink = createMainLink()

  return new ApolloLink((operation, forward) => {
    const context = operation.getContext()

    if (context[APOLLO_CLIENT_CONTEXT_ID.Dato]) {
      return datoLink.request(operation, forward)!
    }

    if (context[APOLLO_CLIENT_CONTEXT_ID.Chat]) {
      return chatLink.request(operation, forward)!
    }

    return mainLink.request(operation, forward)!
  })
}

export default createRequestLink
